export const COMPETERA_EXPERIMENT_CHANNEL = 'tsta'
export const COMPETERA_COOKIE_NUMBER_LIMIT = 9
export const PRODUCT_EXPA_COOKIE_NAME_PREFIX = 'X-cp-'
